/**
 * * Custom JavaScript for Portage College Theme
 * * This file contains custom JavaScript code for the Portage College WordPress theme.
 */
import Glide from '@glidejs/glide'

document.addEventListener("DOMContentLoaded", function () {
  "use strict";

  // Custom JavaScript for Bootstrap validation
  // Fetch all the forms we want to apply custom Bootstrap validation styles to
  const forms = document.querySelectorAll(".needs-validation");

  // Loop over them and prevent submission
  Array.from(forms).forEach((form) => {
    form.addEventListener(
      "submit",
      (event) => {
        if (!form.checkValidity()) {
          event.preventDefault();
          event.stopPropagation();
        }

        form.classList.add("was-validated");
      },
      false
    );
  });

  // Initialize the Glide.js carousel
  const glideElement = document.querySelector('#featuredNewsCarousel');
  if (glideElement) {
    var glide = new Glide('#featuredNewsCarousel', {
      type: 'carousel',
      perView: 1,
      focusAt: 'center',
      gap: 20,
      animationTimingFunc: 'ease',
      peek: {
        before: 100,
        after: 100
      },
      //autoplay: 8000,
      animationDuration: 300,
      hoverpause: true,
      breakpoints: {
        1200: {
          perView: 1,
          gap: 20,
          peek: {
            before: 100,
            after: 100
          }
        },
        768: {
          perView: 1,
          gap: 0,
          peek: 0,
          focusAt: 0
        },
        480: {
          perView: 1,
          gap: 0,
          peek: 0,
          focusAt: 0,
          touchRatio: 0.7,
          swipeThreshold: 50,
          autoplay: false
        }
      }
    });

    glide.mount();

  }
});
